<template lang="pug">
  span.yz-dot(:class="{ 'yz-dot--primary': color === 'primary' }" :style="dotStyle")
</template>

<script>
export default {
  name: "YzDot",
  props: {
    size: {
      type: [String, Number],
      default: '6px'
    },
    color: {
      type: String,
      default: 'primary'
    },
  },
  computed: {
    dotStyle() {
      const style = {}

      // Handle size
      const size = typeof this.size === 'number' ? `${this.size}px` : this.size
      style.width = size
      style.height = size

      // Handle background color
      if (this.color && this.color.startsWith('#')) {
        style.backgroundColor = this.color
      } else if (this.color !== 'primary' && !this.color.startsWith('#')) {
        // Handle design tokens like 'success-500'
        if (this.color.startsWith('yz-')) {
          style.backgroundColor = `var(--${this.color})`
        } else {
          style.backgroundColor = `var(--yz-${this.color})`
        }
      }

      return style
    }
  }
}
</script>

<style scoped>
/* Base dot styles */
.yz-dot {
  display: inline-block;
  box-sizing: border-box;
  border-radius: 50%;
}

/* Color variants - Primary */
.yz-dot--primary {
  background-color: var(--yz-neutral-400);
}
</style>